import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Fundamentos de la Astrología Moderna',
  desc: 'Aprendé el lenguaje del universo, los principios fundamentales de la astrología y cómo se construye una carta natal.'
}, {
  num: '02',
  title: 'Los 12 Signos del Zodíaco en Profundidad',
  desc: 'Descubrí talentos, desafíos, fortalezas, compatibilidades y potencial oculto de cada signo zodiacal.'
}, {
  num: '03',
  title: 'Los Planetas y su Influencia en la Carta Natal',
  desc: 'Comprendé cómo los planetas moldean tu personalidad, emociones, relaciones y propósito de vida.'
}, {
  num: '04',
  title: 'Las 12 Casas Astrológicas',
  desc: 'Descubrí dónde se manifiestan las energías de tu carta natal en las distintas áreas de la vida.'
}, {
  num: '05',
  title: 'Los Aspectos Astrológicos',
  desc: 'Aprendé el lenguaje secreto entre los planetas y cómo interpretar las dinámicas energéticas de una carta natal.'
}, {
  num: '06',
  title: 'Interpretación Profesional de la Carta Natal',
  desc: 'Integrá signos, planetas, casas y aspectos para realizar interpretaciones completas y profesionales.'
}];
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#11152e] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-199">
      <div className="container mx-auto max-w-5xl" data-id="element-200">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-201">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] mb-4" data-id="element-202">
            Formación completa organizada en 6 módulos profesionales
          </h2>
          <p className="text-[#cbd0e0] text-base md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-203">
            Una estructura diseñada para avanzar desde los fundamentos hasta la
            interpretación profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-204">
          {TOMOS.map((tomo, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#1a1f3d] border border-[#d4af37]/15 rounded-xl p-6 transition-all hover:border-[#d4af37]/40 hover:shadow-lg shadow-sm flex gap-5 ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 60}ms`
          }} data-id="element-205">
                <div className="flex-shrink-0" data-id="element-206">
                  <div className="w-14 h-14 rounded-full bg-[#0a0e1f] flex items-center justify-center border-2 border-[#d4af37]/40" data-id="element-207">
                    <span className="text-[#d4af37] font-serif font-bold text-lg" data-id="element-208">
                      {tomo.num}
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-209">
                  <h3 className="text-[#f5f1e6] font-serif font-bold text-xl mb-2 leading-tight" data-id="element-210">
                    {tomo.title}
                  </h3>
                  <p className="text-[#cbd0e0] text-sm leading-relaxed" data-id="element-211">
                    {tomo.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}